import { render, staticRenderFns } from "./ReorderPayment.vue?vue&type=template&id=053bd4c3&scoped=true&"
import script from "./ReorderPayment.vue?vue&type=script&lang=ts&"
export * from "./ReorderPayment.vue?vue&type=script&lang=ts&"
import style0 from "./ReorderPayment.vue?vue&type=style&index=0&id=053bd4c3&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053bd4c3",
  null
  
)

export default component.exports